// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueFirestore from 'vue-firestore'
import VueLocalStorage from 'vue-localstorage'

import vuetify from '@/plugins/vuetify'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'

import chartist from 'chartist'

import TitleBar from '@/components/TitleBar'

import App from '@/App'
import router from '@/router'
import store from '@/store'
import '@/registerServiceWorker' // TODO BETA? review usage. Must trigger refresh after updated event? unregister service-worker.js in src

import TimeAgo from 'javascript-time-ago'
// Load locale-specific relative date/time formatting rules.
import en from 'javascript-time-ago/locale/en'

// import '@babel/polyfill'
import errors from './errors'

import apiHelpers from './plugins/apiHelpers'
import api from './plugins/api'
import dateHelpers from './plugins/dateHelpers'
import snackbar from './utils/snackbar'
import errorHandling from './plugins/errorHandling'

// TODO remove this dependency
import PerfectScrollbar from 'perfect-scrollbar'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import library from './faIcons'
import PortalVue from 'portal-vue'

/* TODO is there a better place to put these? Or just dynamic import? */
import OlTti from '@/components/OlTti.vue'
import OlFolderTab from '@/components/OlFolderTab.vue'

import vuexHelpers from '@/mixins/vuexHelpers'
import { getValueAtPath } from './utils/getValueAtPath'

const runtimeConfig = require('../functions/src/config/rtc.json')

// Vue.config.performance = true && process.env.NODE_ENV !== 'production'

Vue.use(PortalVue, {
  portalName: 'portal-source', // default: 'portal'
  portalTargetName: 'portal-target' // default:'portal-target'
})

Vue.prototype.$fontAwesomeLibrary = library
Vue.component('FontAwesomeIcon', FontAwesomeIcon)

Vue.component('TitleBar', TitleBar)

Vue.component('Oltti', OlTti)
Vue.component('Olfoldertab', OlFolderTab)

Vue.use(apiHelpers)
Vue.use(api)
Vue.use(dateHelpers)
Vue.use(snackbar)
Vue.use(errorHandling)

// International phone number input
Vue.use(VueTelInputVuetify, {
  vuetify
})

// Add locale-specific relative date/time formatting rules.
TimeAgo.locale(en)

Vue.use(VueFirestore)
Vue.use(VueLocalStorage)

Vue.prototype.$Chartist = chartist

// make components available as globals in console when in development
if (
  process.env.NODE_ENV === 'development' ||
  runtimeConfig.app.env === 'development'
) {
  Vue.mixin({
    mounted() {
      if (
        this.$options.name &&
        this.$options.name[0] === this.$options.name[0].toUpperCase()
      ) {
        window[this.$options.name] = this

        // window['CurrentView'] = (components => components[components.length - 1])(this.$router.getMatchedComponents())
        window['CurrentView'] = ((matched) =>
          matched.length && matched[matched.length - 1].instances.default)(
          this.$router.currentRoute.matched
        )
      }
    }
  })
}

Vue.mixin({
  methods: {
    $destroyPerfectScrollbars: function () {
      const refs = this.scrollbarRefs
      if (!this.ps) {
        return
      }
      refs.forEach((ref) => {
        if (this.$refs[ref] && this.ps[ref]) {
          this.ps[ref].destroy()
          this.ps[ref] = null
        }
      })
    },
    $initPerfectScrollbars: async function (psOpts) {
      this.$destroyPerfectScrollbars(this.scrollbarRefs)

      const refs = this.scrollbarRefs
      this.ps = {}
      refs.forEach((ref) => {
        if (this.$refs[ref]) {
          this.ps[ref] = new PerfectScrollbar(
            this.$refs[ref].$el || this.$refs[ref],
            psOpts
          )
        }
      })

      this.$updatePerfectScrollbars()
    },
    $updatePerfectScrollbars: async function () {
      const refs = this.scrollbarRefs
      await this.$nextTick()
      setTimeout(async () => {
        refs.forEach((ref) => {
          if (this.$refs[ref] && this.ps[ref]) {
            this.ps[ref].update()
          }
        })
      }, 250)
    }
  }
})
Vue.prototype.$gnp = getValueAtPath

Vue.prototype.$meIfMe = function (uid, name) {
  return uid === this.$store.state.user.uid ? 'me' : name
}

// Vuex helpers
Vue.mixin(vuexHelpers)

// Create relative date/time formatter.
Vue.prototype.$timeAgo = new TimeAgo('en-GB')
Vue.prototype.$formatFsTimestamp = function (timestamp, style) {
  if (timestamp && timestamp.toDate) {
    return style
      ? this.$timeAgo.format(timestamp.toDate(), style)
      : this.$timeAgo.format(timestamp.toDate())
  }
}

Vue.prototype.$loadUser = async function (uid, include) {
  await this.$store.dispatch('get_knownUsers', { refresh: false, include: include })

  // don't do multiple lookups for the same user
  if (uid in this.$store.state.userLookups) { return }
  this.$store.commit('set_userLookups', uid)

  // if the user is in knownUsers, bail
  if (this.$store.state.knownUsers && uid in this.$store.state.knownUsers) { return }

  // force a refresh if user isn't in the list
  // something has been changed/created with a user not previously known to the logged in user
  await this.$store.dispatch('get_knownUsers', { refresh: true, include: include })

  // user still isn't in list, TODO: add to userlookupMisses collection
}

Vue.prototype.$navMobileBreakpoint = 1120
Vue.prototype.$navWidth = 220

Vue.mixin({
  computed: {

    $vuetifyBpThresholdsArray() {
      return Object.entries(this.$vuetify.breakpoint.thresholds).sort((a, b) => a[1] - b[1])
    },
    $myVuetifyBreakpoint() {
      // figure out the size of the content area based on whether the nav is showing.
      const contentWidth = (window.innerWidth < this.$navMobileBreakpoint
        ? window.innerWidth
        : (window.innerWidth - this.$navWidth)) +
        (window.innerWidth > this.$vuetify.breakpoint.thresholds.md ? this.$vuetify.breakpoint.scrollBarWidth : 0)
      const bp = this.$vuetifyBpThresholdsArray.find(th => contentWidth < th[1])
      const contentClass = 'content-' + ((bp && bp[0]) || 'xl')
      var thLower = 0
      const bools = this.$vuetifyBpThresholdsArray.reduce((acc, th) => {
        acc['content' + th[0]] = contentWidth >= thLower && contentWidth < th[1]
        acc['content' + th[0] + 'Only'] = acc['content' + th[0]]
        acc['content' + th[0] + 'AndDown'] = contentWidth < th[1]
        acc['content' + th[0] + 'AndUp'] = contentWidth >= thLower
        thLower = th[1]
        return acc
      }, {})

      return { ...this.$vuetify.breakpoint, contentClass: contentClass, ...bools }
    }
  }
})

// Directive for nav drawer triggering
/*
Vue.directive('drawer', {
  bind: function (el, binding, vnode) {
    const callback = binding.value
    // const options = binding.options || { passive: true }

    const store = vnode.context.$root.$store
    const navMobileBreakpoint = Vue.prototype.$navMobileBreakpoint

    store.watch(
      (state) => store.state.drawer,
      (newVal, oldVal) => {
        const width = vnode.context.$root.$vuetify.breakpoint.width
        if (width >= navMobileBreakpoint) {
          setTimeout(() => callback(), 220)
        }
      }
    )
  }
}
) */

Vue.config.productionTip = false

errors.init(Vue)

/* eslint-disable no-new */
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
